export default {
    cn: {
        allCommissionReport: {
            title: '代理佣金设定报表',
            type: '代理类型',
            account: '代理账号',
            name: '代理姓名',
            commissionReturn: '代理获得的佣金',
            IB: '代理',
            seek: '搜索',
            CPACommission: 'CPA返佣',
            internalCommission: '内返',
            unit: 'USD',
            downloadExcelForms: '下载 Excel',
            clauses_text: '显示条目数',
            amount: '总数',
            present: '当前',

        }
    },
    hk: {
        allCommissionReport: {
            title: '代理佣金設定報表',
            type: '代理類型',
            account: '代理賬號',
            name: '代理姓名',
            commissionReturn: '代理獲得的佣金',
            IB: '代理',
            seek: '搜索',
            CPACommission: 'CPA返佣',
            internalCommission: '內返',
            unit: 'USD',
            downloadExcelForms: '下載 Excel',
            clauses_text: '顯示條目數',
            amount: '總數',
            present: '當前',

        }
    },
    en: {
        allCommissionReport: {
            title: 'IB Commission Setting Report',
            type: 'IB Type',
            account: 'IB Account',
            name: 'IB Name',
            commissionReturn: 'Commission Rebate',
            IB: 'IB',
            seek: 'Search',
            CPACommission: 'CPA Commission',
            internalCommission: 'Internal Commission',
            unit: 'USD',
            downloadExcelForms: 'Download Excel',
            clauses_text: 'Display',
            amount: ' Total Count',
            present: 'Current',

        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/allCommissionReport.js